import { LibraryIndex } from '@/components/library-index';
import {
  NewQuizForm,
  QuestionBankDetail,
  QuestionBankForm,
  QuestionBanks,
  QuestionEditor,
  QuizList,
} from '@/components/quiz/authoring';
import { PageHeader } from '@/components/ui';
import { CourseList, NewCourseForm } from '@/pages/course/authoring';
import { EventList, NewEventForm } from '@/components/event/authoring';

const LIBRARY = { kind: 'library' } as const;
const BASE = '/admin/library';

/** Nirvik's library: public content every organization can use, one page per kind. */
export function AdminLibraryPage() {
  return (
    <LibraryIndex
      base={BASE}
      who="nirvik"
      intro="Nirvik’s own content: open to everyone when public, and reusable by every organization."
    />
  );
}

export function AdminLibraryQuizzesPage() {
  return (
    <>
      <PageHeader
        title="Nirvik quizzes"
        description="Self-assessments and challenges in Nirvik's library, built from its question banks."
        back={{ to: BASE, label: 'Library' }}
      />
      <QuizList owner={LIBRARY} base={BASE} />
    </>
  );
}

export function AdminLibraryNewQuizPage() {
  return <NewQuizForm owner={LIBRARY} back={{ to: `${BASE}/quizzes`, label: 'Quizzes' }} />;
}

export function AdminLibraryBanksPage() {
  return (
    <>
      <PageHeader
        title="Nirvik question banks"
        description="Every organization's authors can reuse these."
        back={{ to: BASE, label: 'Library' }}
      />
      <QuestionBanks owner={LIBRARY} base={BASE} />
    </>
  );
}

export function AdminLibraryBankFormPage() {
  return <QuestionBankForm owner={LIBRARY} base={BASE} />;
}

export function AdminLibraryBankPage() {
  return <QuestionBankDetail owner={LIBRARY} base={BASE} />;
}

export function AdminLibraryQuestionEditorPage() {
  return <QuestionEditor base={BASE} />;
}

export function AdminLibraryCoursesPage() {
  return (
    <>
      <PageHeader
        title="Nirvik courses"
        description="Courses in Nirvik's library. Organizations can take them, and clone them to customize."
        back={{ to: BASE, label: 'Library' }}
      />
      <CourseList owner={LIBRARY} base={BASE} />
    </>
  );
}

export function AdminLibraryNewCoursePage() {
  return <NewCourseForm owner={LIBRARY} back={{ to: `${BASE}/courses`, label: 'Courses' }} />;
}

export function AdminLibraryEventsPage() {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Workshops and webinars"
        description="Nirvik's live events, open to everyone."
        back={{ to: BASE, label: 'Library' }}
      />
      <EventList owner={LIBRARY} base={BASE} />
    </div>
  );
}

export function AdminLibraryNewEventPage() {
  return <NewEventForm owner={LIBRARY} back={{ to: `${BASE}/events`, label: 'Events' }} />;
}
